<!--
 * @Author: LeeHuiXian
 * @version:
 * @Date: 2020-10-14 11:12:00
 * @LastEditors: LeeHuiXian
 * @LastEditTime: 2020-10-27 15:35:57
 * @FilePath: /goldenSalesMobile/src/views/ShoppingList/index.vue
 * @Description: 消费者购物商品列表
-->
<template>
  <div class="page-container">
    <!-- banner -->
    <div class="banner-list" v-if="bannerList.length > 0">
      <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
        <van-swipe-item v-for="(item, index) in bannerList" :key="index">
          <van-image :src="`${item.CdnUrl}/${item.ImagePath}`" fit="cover" />
        </van-swipe-item>
      </van-swipe>
    </div>
    <!-- goods-list -->
    <div class="tab-list c-p-20">
      <van-tabs
        v-model="activeTabName"
        swipeable
        sticky
        color="var(--tc)"
        title-active-color="var(--tc)"
        title-inactive-color="#666666"
        @change="onTabChange"
      >
        <van-tab
          v-for="(item, index) in tabList"
          :key="index"
          :name="item.Id"
          :title="item.Name"
          :swipe-threshold="5"
        >
          <van-list
            v-model="loading"
            :finished="finished"
            :error.sync="loadError"
            :immediate-check="false"
            :offset="30"
            error-text="请求失败，点击重新加载"
            finished-text="没有更多了"
            @load="onLoad"
          >
            <div
              class="goods-item"
              v-for="(subItem, subIndex) in item.goodsList"
              :key="subIndex"
              @click="onCheckDetail(subItem.Id, subIndex)"
            >
              <div class="goods-image">
                <van-image
                  :src="subItem.imgUrl"
                  fit="cover"
                  width="120"
                  height="120"
                  radius="10"
                />
              </div>
              <div class="dotted-box">
                <van-image
                  width="25"
                  height="21"
                  :src="require('@/assets/images/douhao@2x.png')"
                ></van-image>
                <p class="main-txt">{{ subItem.Name }}</p>
              </div>
              <div
                class="sub-txt"
                v-html="
                  subItem.GoodsList.map(
                    (m) => `${m.GoodsName} x ${m.NumberCount}`
                  ).join('　')
                "
              ></div>
              <div class="money-box">
                <div class="main-money c-tc">
                  <span class="c-yang">¥</span>
                  <span class="">{{ subItem.MarketPrice }}</span>
                </div>
                <div class="sub-money" v-if="subItem.ScribePrice">
                  ￥{{ subItem.ScribePrice }}
                </div>
              </div>
            </div>
          </van-list>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
import { testGetAESPhone, silentLogin } from "@/api/user";
import { getToken } from "@/utils/auth";
import { getStoreBanner } from "@/api/system";
import { getProductTypeList, getProductList } from "@/api/goods";
// ~/jinguiProject/goldenTicket/goldenSalesMobile-in-mobile/src/views/ShoppingList
// ~/jinguiProject/goldenTicket/goldenSalesMobile-in-mobile/src/views/ShoppingList/index.vue
export default {
  data() {
    return {
      userInfo: {
        phone: this.$route.query.phone,
        name: this.$route.query.userName,
        headImageUrl: this.$route.query.headImageUrl,
      },
      bannerList: [],
      loading: false,
      finished: false,
      loadError: false,
      activeTabName: "",
      tabList: [],
      pageIndex: 0,
      pageSize: 5,
    };
  },

  created() {
    this.init();
  },

  methods: {
    // 初始化
    async init() {
      let token = getToken();
      if (!token) {
        // TODO 去掉getTestPhone方法调用和testGetAESPhone方法的定义，phone将从url后面截取
        // this.userInfo.phone = await this.getTestPhone()
        // await this.handlerlogin(this.userInfo.phone)
      }

      // 获取商户Banner
      // getStoreBanner()
      //   .then(res => {
      //     let data = res.Items
      //     if (data instanceof Array && data.length > 0) {
      //       this.bannerList = data
      //     }
      //   })

      // 加载产品列表前5条数据
      getProductTypeList().then((res) => {
        let data = res;
        if (data instanceof Array && data.length > 0) {
          this.tabList.unshift({ Name: "全部", Id: "", goodsList: [] });
          data.map((item) => {
            if (item.Status.Id === 0) {
              // 仅显示‘已上架’的分类
              item.goodsList = [];
              this.tabList.push(item);
            }
          });
          this.getProducts();
          this.getMyProductList();
        }
      });
    },

    getMyProductList() {
      let params = {
        query: {
          type: this.activeTabName,
        },
        pager: {
          pageindex: this.pageIndex,
          pagesize: this.pageSize,
        },
      };
      $http("mobile/zh-cn/v1/product", params).then((res) => {
        console.log("99999<<<  res  >>>99999");
        console.log(res);
      });
    },

    // 产品列表请求方法
    getProducts() {
      getProductList({
        query: {
          type: this.activeTabName,
        },
        pager: {
          pageindex: this.pageIndex,
          pagesize: this.pageSize,
        },
      })
        .then((res) => {
          let data = res.Items;
          if (data instanceof Array) {
            data.map((item) => {
              // 产品列表图片
              const imgArr = item.Claims;
              if (imgArr instanceof Array && imgArr.length > 0) {
                imgArr.map((subItem) => {
                  if (subItem.TypeId === 0) {
                    item.imgUrl = `${subItem.CdnUrl}/${subItem.Value}`;
                  }
                });
              }
            });
            // 添加产品数据到对应的tabList中
            this.tabList.map((item) => {
              if (item.Id === this.activeTabName) {
                if (this.pageIndex > 1) {
                  // 合并
                  item.goodsList = item.goodsList.concat(data);
                } else {
                  // 覆盖
                  item.goodsList = data;
                }
              }
            });
            // 没有更多数据时结束上拉加载事件
            if (data.length < this.pageSize || data.length === 0) {
              this.finished = true;
            }
            // 加载结束
            this.loading = false;
          }
        })
        .catch((err) => {
          // console.log(err)
          this.loadError = true;
          this.loading = false;
        });
    },

    // 上拉加载
    onLoad() {
      // console.log('上拉加载')
      this.pageIndex++;
      this.getProducts();
      this.getMyProductList();
    },

    // tab切换
    onTabChange(val) {
      console.log("99999<<<  val  >>>99999");
      console.log(val);
      this.finished = false;
      this.loading = true;
      this.activeTabName = val;
      this.pageIndex = 0;
      this.getProducts();
      let activeRef = document.getElementsByClassName("van-tab--active");
      console.log("11111<<<  activeRef  >>>11111");
      console.log(activeRef);
      console.log("22222<<<  activeRef[0].style.offsetWidth  >>>22222");
      console.log(activeRef[0].offsetWidth);
      console.log(activeRef[0].offsetLeft);
      let offLeft = activeRef[0].offsetLeft;
      let tab_line = document.getElementsByClassName("van-tabs__line")[0];
      console.log(
        "%c tab_line ",
        "background-image:color:transparent;color:red;font-size:2em"
      );
      console.log(tab_line);

      this.$nextTick(() => {
        console.log("66666<<<  tab_line.style  >>>66666");
        console.log(tab_line.style);
        console.log(tab_line.style.transform);
        tab_line.style.color = "pink";
        tab_line.style.backgroundColor = "pink";
        tab_line.style.transform = "translateX(112px) translateX(-50%)";
      });
    },

    // 查看产品详情
    onCheckDetail(productId, i) {
      this.$router.push({
        name: "SaleGoodsDetail",
        params: { id: productId },
      });
      // this.$router.push({
      //   name: 'GoodsDetail',
      //   params: { id: productId }
      // })
    },
  },
};
</script>

<style lang="scss" scoped>
.page-container {
  min-height: 100vh;
  .banner-list {
    width: 100%;
    height: 300px;

    > .my-swipe {
      width: 100%;
      height: 100%;
      // border-radius: 16px;
      // overflow: hidden;

      &::v-deep .van-image {
        width: 100%;
        height: 100%;
      }
    }
  }

  .tab-list {
    width: 100%;
    background: #fff;
    margin-bottom: 100px;
    box-sizing: border-box;
    min-height: 100vh;

    .goods-item {
      padding: 28px 28px 0 28px;
      position: relative;
      /* height: 340px; */
      background: #f2f4f7;
      margin: 100px 0 0 0;
      border-radius: 20px;

      .goods-image {
        position: absolute;
        top: -60px;
        ::v-deep .van-image {
          box-shadow: 0 0 0 1px rgba(1, 1, 1, 0.1);
        }
      }

      .dotted-box {
        margin-left: 280px;
        margin-bottom: 20px;
        .goods-name {
          margin-bottom: 12px;
          line-height: 48px;
          font-size: 34px;
          font-weight: 500;
          color: #333333;
        }
        .main-txt {
          font-size: 32px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #333333;
          margin-top: 10px;
          line-height: 44px;
        }

        .goods-intro,
        .goods-salesCount {
          min-height: 34px;
          margin-bottom: 10px;
          line-height: 34px;
          font-size: 24px;
          color: #888888;
        }

        .goods-salesCount {
          > a > b {
            font-weight: normal;
            text-decoration: line-through;
          }
        }

        .goods-name,
        .goods-intro {
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2; // 用来限制在一个块元素显示的文本的行数
          overflow: hidden;
        }

        .goods-price {
          @include flex-box(space-between);

          > span {
            line-height: 30px;
            font-size: 40px;
            font-weight: bold;
            color: #fe4600;

            > a {
              font-size: 24px;
            }
          }

          &::v-deep .van-button {
            width: 90px;
            height: 30px;
            line-height: 30px;

            .van-button__text {
              font-weight: 500;
            }
          }
        }
      }
      .sub-txt {
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 34px;
        height: 34px;
        min-height: 34px;
        margin: 40px 0 0 0;
        box-sizing: border-box;
      }
      .money-box {
        /* width: 30%; */
        display: flex;
        flex-direction: row-reverse;
        align-items: baseline;
        margin-top: 40px;
        .sub-money {
          font-size: 24px;
          font-family: Cochin;
          color: #cccccc;
          line-height: 28px;
          margin-right: 20px;
          text-decoration: line-through;
        }
        .main-money {
          height: 58px;
          font-size: 50px;
          font-family: Cochin-Bold, Cochin;
          font-weight: bold;
          line-height: 28px;
        }
      }
    }
  }
}
/* 
::v-deep .van-tab {
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  box-sizing: border-box;
  padding: 0 4px;
  color: #646566;
  font-size: 14px;
  line-height: 20px;
  cursor: pointer;
  flex: none;
  margin-right: 20px;
}
::v-deep .van-tab--active .van-tab__text--ellipsis,
::v-deep .van-tab--active .van-tab__text {
  font-size: 24px;
  transition-property: color, background;
  transition-duration: 3s, 3s;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: var(--tc) !important;
}
::v-deep .van-tab__text--ellipsis {
  -webkit-line-clamp: unset;
  overflow: unset;
}
::v-deep .van-tabs__line {
  background: var(--tc) !important;
} */
</style>
